const MIN_ROW_TILES = 10;
const SECONDS_PER_TILE = 5;
export function distributeLogoWallItems<T>(items: T[], rowCount: number): T[][] {
  const rows: T[][] = Array.from({
    length: rowCount
  }, () => []);
  items.forEach((item, index) => rows[index % rowCount]!.push(item));
  return rows;
}

/** Build the duplicated track needed for a seamless 50% translate loop. */
export function createMarqueeRowModel<T>(logos: T[]) {
  if (!logos.length) {
    return {
      accessibleTileCount: 0,
      durationSeconds: 0,
      tiles: [] as T[]
    };
  }
  const repetitions = Math.max(2, Math.ceil(MIN_ROW_TILES / logos.length));
  const filled = Array.from({
    length: repetitions
  }).flatMap(() => logos);
  return {
    accessibleTileCount: logos.length,
    durationSeconds: filled.length * SECONDS_PER_TILE,
    tiles: [...filled, ...filled]
  };
}

/** Resolve responsive row direction and retain the optional CMS headline verbatim. */
export function createLogoWallPresentation<T>(input: {
  headline?: string | null;
  isLarge: boolean;
  logos: T[];
  prefersReducedMotion: boolean;
}) {
  const directions = input.isLarge ? [false, true] : [false, true, false];
  return {
    directions,
    headline: input.headline || null,
    rows: distributeLogoWallItems(input.logos, directions.length),
    staticGrid: input.prefersReducedMotion
  };
}